import "./polyfills";
import { createRoot, hydrateRoot } from "react-dom/client";
import * as Scrivito from "scrivito";
import "./Objs";
import "./Widgets";
import { App } from "./App";
import configure from "./config";
import "./assets/stylesheets/index.scss";

configure();

if (window.preloadDump) {
  Scrivito.preload(window.preloadDump).then(({ dumpLoaded }) => {
    delete window.preloadDump;
    const _ = dumpLoaded ? hydrateApp() : renderApp();
  });
} else {
  renderApp();
}

function renderApp() {
  createRoot(document.getElementById("application")).render(<App />);
}

function hydrateApp() {
  hydrateRoot(
    document.getElementById("application"),
    <App
      appWrapperRef={(el) => {
        if (el) Scrivito.updateContent();
      }}
    />
  );
}
